module.exports = __webpack_public_path__ + "static/media/we3academy_gridexample_saxoneldridge.29246036.jpg";